export const RERUN_SCOPE = {
  everything: "everything",
  units: "units",
} as const;

export type RerunScope = (typeof RERUN_SCOPE)[keyof typeof RERUN_SCOPE];
